'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('@material-ui/core/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMSvgIcon = function WMSvgIcon(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_SvgIcon2.default, props)
	);
};

WMSvgIcon.displayName = 'WMSvgIcon';

exports.default = WMSvgIcon;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMSvgIcon/index.js